import React, { useEffect, useState, useCallback } from "react";
import { withTranslation } from "react-i18next";
import "../ln.scss";
import "./style.scss";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import {
  FilterOutlined,
  DownloadOutlined,
  SearchOutlined,
  ReloadOutlined,
  FileTextOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import axios from "axios";
import url from "../../../url.json";
import headers from "../../../config/headers";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import dateFormat from "dateformat";
import { Empty, Pagination, Spin, Select } from "antd";
import { Helmet } from "react-helmet-async";

const { Option } = Select;

function formatDate(dateValue) {
  if (!dateValue) return "-";
  try {
    const d = new Date(dateValue);
    if (isNaN(d.getTime())) return String(dateValue);
    return dateFormat(d, "dd.mm.yyyy");
  } catch (e) {
    return String(dateValue);
  }
}

// Amal qilish muddati tugamagan (yoki ko'rsatilmagan) guvohnoma
function isActive(endDate) {
  if (!endDate) return true;
  const d = new Date(endDate);
  return isNaN(d.getTime()) || d >= new Date(new Date().toDateString());
}

function getSafeValue(val, fallback = "-") {
  if (val === null || val === undefined || val === "") return fallback;
  return val;
}

function ReestrRow({ row, lan, t }) {
  const [open, setOpen] = useState(false);

  // Flexible fields extraction
  const certNumber =
    row.number || row.certificate_number || row.registry_number || row.reg_number || "-";
  const startDate = row.start_date || row.given_date || row.issue_date || row.date;
  const endDate = row.end_date || row.expire_date || row.expiry_date;
  const drugName = row.drug?.name || row.drug_name || row.name || "-";
  const tradeName = row.drug?.trade_name || row.trade_name;
  const drugFigure = row.drug?.drug_figure?.name || row.drug_figure || row.figure;
  const structure = row.drug?.structure || row.structure;
  const countryName =
    row.drug?.country?.name || row.country?.name || row.country || "-";
  // Tizim orqali berilganlarda to'liq ma'lumot (manzil, aloqa), qo'lda kiritilganlarda faqat nomi
  const manufacturerInfo = row.manufacturer_info || row.drug?.manufacturer || null;
  const preparerInfo = row.preparer_info || row.drug?.preparer || null;
  const manufacturerName =
    manufacturerInfo?.name || row.manufacturer?.name || row.manufacturer || "-";
  const manufacturerCountry = manufacturerInfo?.country?.name || manufacturerInfo?.country;
  const preparerName = preparerInfo?.name || row.preparer?.name || row.preparer;
  const usage = row.drug?.usage || row.usage;
  // Dublikat berilgan guvohnoma: reestrdagi ma'lumotlar dublikatdan, eski raqam alohida
  const duplicate = row.is_duplicate ? row.duplicate || {} : null;

  const legalEntityName =
    row.legal_entity?.name || row.applicant || row.owner || row.company_name || "-";
  const bossName = row.legal_entity?.boss_name || row.boss_name;
  const email = row.legal_entity?.email || row.email;
  const address = row.legal_entity?.address || row.address;
  const phone = row.legal_entity?.phone || row.phone;

  const instruction = row.drug?.instruction || row.instruction;

  const getInstructionText = (inst) => {
    if (!inst) return "";
    if (typeof inst === "string") return inst;
    if (typeof inst === "object") {
      return inst[lan] || inst["uz"] || inst["ru"] || inst["en"] || "";
    }
    return "";
  };

  return (
    <React.Fragment>
      <TableRow
        className="table-body-row"
        hover
        onClick={() => setOpen(!open)}
      >
        <TableCell>
          <span className="cert-number-badge">{certNumber}</span>
          {duplicate && (
            <>
              <span className="cert-duplicate-badge" title={t("Registry duplicate hint")}>
                {t("Registry duplicate")}
              </span>
              {duplicate.original_number && (
                <small className="cert-old-number">
                  {t("Previous certificate number")}: {duplicate.original_number}
                </small>
              )}
            </>
          )}
        </TableCell>
        <TableCell>
          <span className="date-text">
            {formatDate(startDate)}
            {endDate ? <small>— {formatDate(endDate)}</small> : ""}
          </span>
        </TableCell>
        <TableCell>
          {isActive(endDate) ? (
            <span className="ln-pill ln-pill_ok">{t("ln_valid")}</span>
          ) : (
            <span className="ln-pill ln-pill_warn">{t("ln_expired")}</span>
          )}
        </TableCell>
        <TableCell>
          <div className="drug-name-text">{drugName}</div>
          {tradeName && tradeName !== drugName && (
            <small style={{ color: "#8c9ba5" }}>({tradeName})</small>
          )}
        </TableCell>
        <TableCell>
          <span className="country-text">{countryName}</span>
        </TableCell>
        <TableCell>
          {/* manzil tafsilotlarda ko'rsatiladi — jadval sig'ishi uchun bu yerda faqat nomi */}
          <div className="manufacturer-cell">{manufacturerName}</div>
        </TableCell>
        <TableCell>{legalEntityName}</TableCell>
        <TableCell align="right" className="action-cell" onClick={(e) => e.stopPropagation()}>
          <IconButton
            aria-label="expand row"
            size="small"
            className="row-toggle"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
      </TableRow>

      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={8}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box className="details-box">
              <div className="details-grid">
                {/* 1. Arizachi ma'lumotlari */}
                <div className="details-section">
                  <div className="section-header">
                    <FileTextOutlined />
                    <span>{t("Applicant_Information") || "Arizachi ma'lumotlari"}</span>
                  </div>
                  <div className="detail-row">
                    <span className="detail-label">{t("Applicant") || "Arizachi"}:</span>
                    <span className="detail-value highlight">{getSafeValue(legalEntityName)}</span>
                  </div>
                  {bossName && (
                    <div className="detail-row">
                      <span className="detail-label">{t("Head_of_company") || "Rahbar"}:</span>
                      <span className="detail-value">{bossName}</span>
                    </div>
                  )}
                  {phone && (
                    <div className="detail-row">
                      <span className="detail-label">{t("Phone") || "Telefon"}:</span>
                      <span className="detail-value">{phone}</span>
                    </div>
                  )}
                  {email && (
                    <div className="detail-row">
                      <span className="detail-label">{t("Email") || "Email"}:</span>
                      <span className="detail-value">{email}</span>
                    </div>
                  )}
                  {address && (
                    <div className="detail-row">
                      <span className="detail-label">{t("Address") || "Manzil"}:</span>
                      <span className="detail-value">{address}</span>
                    </div>
                  )}
                </div>

                {/* 2. Dori vositasi ma'lumotlari */}
                <div className="details-section">
                  <div className="section-header">
                    <FileTextOutlined />
                    <span>{t("Drug Information") || "Dori vositasi ma'lumotlari"}</span>
                  </div>
                  <div className="detail-row">
                    <span className="detail-label">{t("Drug name") || "Nomi"}:</span>
                    <span className="detail-value highlight">{getSafeValue(drugName)}</span>
                  </div>
                  {tradeName && (
                    <div className="detail-row">
                      <span className="detail-label">{t("Trade name") || "Savdo nomi"}:</span>
                      <span className="detail-value">{tradeName}</span>
                    </div>
                  )}
                  {drugFigure && (
                    <div className="detail-row">
                      <span className="detail-label">{t("Drug form") || "Dori shakli"}:</span>
                      <span className="detail-value">{drugFigure}</span>
                    </div>
                  )}
                  {structure && (
                    <div className="detail-row">
                      <span className="detail-label">{t("Content") || "Tarkibi"}:</span>
                      <span className="detail-value">{structure}</span>
                    </div>
                  )}
                  <div className="detail-row">
                    <span className="detail-label">{t("Country") || "Mamlakat"}:</span>
                    <span className="detail-value">{getSafeValue(countryName)}</span>
                  </div>
                  {usage && (
                    <div className="detail-row">
                      <span className="detail-label">{t("Applicat") || "Qo'llanilishi"}:</span>
                      <span className="detail-value">{usage}</span>
                    </div>
                  )}
                </div>

                {/* 3. Ishlab chiqaruvchi (va tayyorlovchi) */}
                <div className="details-section">
                  <div className="section-header">
                    <FileTextOutlined />
                    <span>{t("Manufacturer") || "Ishlab chiqaruvchi"}</span>
                  </div>
                  <div className="detail-row">
                    <span className="detail-label">{t("Name") || "Nomi"}:</span>
                    <span className="detail-value highlight">{getSafeValue(manufacturerName)}</span>
                  </div>
                  {manufacturerCountry && (
                    <div className="detail-row">
                      <span className="detail-label">{t("Country") || "Mamlakat"}:</span>
                      <span className="detail-value">{manufacturerCountry}</span>
                    </div>
                  )}
                  {manufacturerInfo?.address && (
                    <div className="detail-row">
                      <span className="detail-label">{t("Address") || "Manzil"}:</span>
                      <span className="detail-value">{manufacturerInfo.address}</span>
                    </div>
                  )}
                  {manufacturerInfo?.phone && (
                    <div className="detail-row">
                      <span className="detail-label">{t("Phone") || "Telefon"}:</span>
                      <span className="detail-value">{manufacturerInfo.phone}</span>
                    </div>
                  )}
                  {manufacturerInfo?.fax && (
                    <div className="detail-row">
                      <span className="detail-label">{t("Fax") || "Faks"}:</span>
                      <span className="detail-value">{manufacturerInfo.fax}</span>
                    </div>
                  )}
                  {manufacturerInfo?.email && (
                    <div className="detail-row">
                      <span className="detail-label">{t("Email") || "Email"}:</span>
                      <span className="detail-value">{manufacturerInfo.email}</span>
                    </div>
                  )}
                  {preparerName && preparerName !== manufacturerName && (
                    <>
                      <div className="detail-row detail-row-divider">
                        <span className="detail-label">{t("Preparer") || "Tayyorlovchi"}:</span>
                        <span className="detail-value highlight">{preparerName}</span>
                      </div>
                      {preparerInfo?.address && (
                        <div className="detail-row">
                          <span className="detail-label">{t("Address") || "Manzil"}:</span>
                          <span className="detail-value">{preparerInfo.address}</span>
                        </div>
                      )}
                      {(preparerInfo?.country?.name || preparerInfo?.country) && (
                        <div className="detail-row">
                          <span className="detail-label">{t("Country") || "Mamlakat"}:</span>
                          <span className="detail-value">{preparerInfo?.country?.name || preparerInfo?.country}</span>
                        </div>
                      )}
                    </>
                  )}
                </div>

                {/* 4. Sertifikat / Reestr ma'lumotlari */}
                <div className="details-section">
                  <div className="section-header">
                    <FileTextOutlined />
                    <span>{t("Sertificat") || "Sertifikat ma'lumotlari"}</span>
                  </div>
                  <div className="detail-row">
                    <span className="detail-label">{t("Registration number") || "Reestr raqami"}:</span>
                    <span className="detail-value highlight">
                      {getSafeValue(certNumber)}
                      {duplicate && <span className="cert-duplicate-badge">{t("Registry duplicate")}</span>}
                    </span>
                  </div>
                  {duplicate?.original_number && (
                    <div className="detail-row">
                      <span className="detail-label">{t("Previous certificate number")}:</span>
                      <span className="detail-value">{duplicate.original_number}</span>
                    </div>
                  )}
                  {duplicate?.issued_at && (
                    <div className="detail-row">
                      <span className="detail-label">{t("Duplicate issued on")}:</span>
                      <span className="detail-value">{formatDate(duplicate.issued_at)}</span>
                    </div>
                  )}
                  <div className="detail-row">
                    <span className="detail-label">{t("Registration date") || "Berilgan sana"}:</span>
                    <span className="detail-value">{formatDate(startDate)}</span>
                  </div>
                  {endDate && (
                    <div className="detail-row">
                      <span className="detail-label">{t("Date range") || "Amal qilish muddati"}:</span>
                      <span className="detail-value">{formatDate(endDate)}</span>
                    </div>
                  )}
                </div>
              </div>

              {/* Qo'shimcha yo'riqnoma bo'limi agar mavjud bo'lsa */}
              {instruction && (
                <div className="details-section" style={{ marginTop: 16 }}>
                  <div className="section-header">
                    <FileTextOutlined />
                    <span>{t("Instruction") || "Yo'riqnoma"}</span>
                  </div>
                  {instruction.general && (
                    <div className="detail-row" style={{ flexDirection: "column", gap: 4 }}>
                      <span className="detail-label">{t("general") || "Umumiy ma'lumot"}:</span>
                      <div
                        className="detail-value"
                        dangerouslySetInnerHTML={{
                          __html: getInstructionText(instruction.general),
                        }}
                      />
                    </div>
                  )}
                  {instruction.pharmacological && (
                    <div className="detail-row" style={{ flexDirection: "column", gap: 4, marginTop: 8 }}>
                      <span className="detail-label">{t("pharmacological") || "Farmakologik xususiyatlari"}:</span>
                      <div
                        className="detail-value"
                        dangerouslySetInnerHTML={{
                          __html: getInstructionText(instruction.pharmacological),
                        }}
                      />
                    </div>
                  )}
                  {instruction.usage && (
                    <div className="detail-row" style={{ flexDirection: "column", gap: 4, marginTop: 8 }}>
                      <span className="detail-label">{t("usage") || "Qo'llash usuli"}:</span>
                      <div
                        className="detail-value"
                        dangerouslySetInnerHTML={{
                          __html: getInstructionText(instruction.usage),
                        }}
                      />
                    </div>
                  )}
                </div>
              )}
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

function ReestrNew({ t }) {
  const lan = useSelector((state) => state.langReducer?.value || "uz");
  const [countries, setCountries] = useState([]);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [exportLoading, setExportLoading] = useState(false);

  // Filter state
  const [filters, setFilters] = useState({
    number: "",
    name: "",
    country_id: "",
    applicant: "",
    start_date: "",
    end_date: "",
  });

  // Mamlakatlar ro'yxatini olish
  useEffect(() => {
    axios
      .get(url.url + "/country", { headers: headers() })
      .then((res) => {
        const countryList = res.data?.data || res.data || [];
        setCountries(countryList);
      })
      .catch((err) => {
        console.error("Country load error:", err);
      });
  }, [lan]);

  // Ma'lumotlarni yuklab olish funksiyasi
  const fetchRegistryData = useCallback(
    (page = 1, currentFilters = filters) => {
      setLoading(true);
      const params = new URLSearchParams();
      params.append("page", page);

      if (currentFilters.number) params.append("number", currentFilters.number.trim());
      if (currentFilters.name) params.append("name", currentFilters.name.trim());
      if (currentFilters.country_id) params.append("country_id", currentFilters.country_id);
      if (currentFilters.applicant) params.append("applicant", currentFilters.applicant.trim());
      if (currentFilters.start_date) params.append("start_date", currentFilters.start_date);
      if (currentFilters.end_date) params.append("end_date", currentFilters.end_date);

      const requestUrl = `${url.url}/certificate-registry?${params.toString()}`;

      axios
        .get(requestUrl, { headers: headers() })
        .then((res) => {
          setLoading(false);
          // Turli formatdagi javoblarni to'g'ri o'qish
          const responseData = res.data?.data || res.data;
          setData(responseData);
          setCurrentPage(page);
        })
        .catch((err) => {
          setLoading(false);
          console.error("Registry load error:", err);
          if (err.response?.status === 401) {
            localStorage.removeItem("token");
            localStorage.removeItem("user");
            window.location = "/";
          } else {
            toast.error(err.response?.data?.message || err.message || "Xatolik yuz berdi");
          }
        });
    },
    [filters]
  );

  // Dastlabki yuklash
  useEffect(() => {
    fetchRegistryData(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lan]);

  // Input qiymatlari o'zgarishi
  const handleFilterChange = (field, value) => {
    setFilters((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  // Filtrni qo'llash
  const handleApplyFilter = (e) => {
    if (e) e.preventDefault();
    setCurrentPage(1);
    fetchRegistryData(1, filters);
  };

  // Filtrni tozalash
  const handleResetFilter = () => {
    const emptyFilters = {
      number: "",
      name: "",
      country_id: "",
      applicant: "",
      start_date: "",
      end_date: "",
    };
    setFilters(emptyFilters);
    setCurrentPage(1);
    fetchRegistryData(1, emptyFilters);
  };

  // Sahifa almashtirish
  const handlePageChange = (page) => {
    setCurrentPage(page);
    fetchRegistryData(page, filters);
    window.scrollTo({ top: 120, behavior: "smooth" });
  };

  // Eksport qilish funksiyasi (Excel)
  const handleExport = async () => {
    if (exportLoading) return;
    setExportLoading(true);
    try {
      const params = new URLSearchParams();
      if (filters.number) params.append("number", filters.number.trim());
      if (filters.name) params.append("name", filters.name.trim());
      if (filters.country_id) params.append("country_id", filters.country_id);
      if (filters.applicant) params.append("applicant", filters.applicant.trim());
      if (filters.start_date) params.append("start_date", filters.start_date);
      if (filters.end_date) params.append("end_date", filters.end_date);

      const queryString = params.toString();
      const exportUrl = `${url.url}/certificate-registry/export${queryString ? `?${queryString}` : ""}`;

      const response = await axios.get(exportUrl, {
        headers: headers(),
        responseType: "blob",
      });

      // Fayl nomini aniqlash (Content-Disposition dan yoki default)
      let filename = "reestr_certificates.xlsx";
      const disposition = response.headers?.["content-disposition"];
      if (disposition && disposition.indexOf("filename=") !== -1) {
        const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(disposition);
        if (matches != null && matches[1]) {
          filename = matches[1].replace(/['"]/g, "");
        }
      }

      const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = blobUrl;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(blobUrl);

      toast.success(t("Success") || "Fayl muvaffaqiyatli yuklab olindi");
    } catch (err) {
      console.error("Export error:", err);
      toast.error(
        err.response?.data?.message ||
          t("Export failed") ||
          "Faylni yuklab olishda xatolik yuz berdi"
      );
    } finally {
      setExportLoading(false);
    }
  };

  // Ro'yxat elementlari
  const registryItems =
    data?.result || (Array.isArray(data) ? data : data?.data || []);

  const totalCount =
    data?.pagination?.total || data?.total || registryItems.length || 0;
  const perPage = data?.pagination?.per_page || data?.per_page || 15;

  return (
    <div className="reestr-new-page ln">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Vis Nefrit | {t("Reestr") || "Sertifikatlar reestri"}</title>
        <meta
          name="description"
          content={t("herotitle") || "Veterinariya dori vositalari reestri"}
        />
      </Helmet>

      <div className="reestr-hero">
        <div className="reestr-container">
          <span className="ln-eyebrow">{t("ln_ql_reg_text")}</span>
          <h1 className="reestr-hero__title">{t("ln_reg_title")}</h1>
          <p className="reestr-hero__text">{t("ln_reg_text")}</p>
          {data?.pagination?.total ? (
            <div className="reestr-hero__stat">
              <strong>{Number(data.pagination.total).toLocaleString("ru-RU")}</strong>
              <span>{t("Total results") || "Jami natijalar"}</span>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>

      <div className="reestr-container reestr-body">

        {/* Filtr bo'limi */}
        <div className="filter-card">
          <div className="filter-title">
            <FilterOutlined />
            <span>{t("Filter") || "Qidiruv va filtrlar"}</span>
          </div>

          <form onSubmit={handleApplyFilter}>
            <div className="filter-grid">
              {/* Ro'yxatga olish raqami */}
              <div className="filter-item">
                <label>{t("Registration number") || "Ro'yxatga olish raqami"}</label>
                <input
                  type="text"
                  className="filter-input"
                  placeholder={t("Registration number") || "Raqamni kiriting"}
                  value={filters.number}
                  onChange={(e) => handleFilterChange("number", e.target.value)}
                />
              </div>

              {/* Dori vositasi nomi */}
              <div className="filter-item">
                <label>{t("Drug name") || "Dori vositasi nomi"}</label>
                <input
                  type="text"
                  className="filter-input"
                  placeholder={t("Drug name") || "Dori nomini kiriting"}
                  value={filters.name}
                  onChange={(e) => handleFilterChange("name", e.target.value)}
                />
              </div>

              {/* Mamlakat */}
              <div className="filter-item">
                <label>{t("Country") || "Mamlakat"}</label>
                <Select
                  showSearch
                  allowClear
                  className="filter-select-antd"
                  placeholder={t("Country") || "Mamlakatni tanlang yoki qidiring"}
                  optionFilterProp="children"
                  value={filters.country_id || undefined}
                  onChange={(val) => handleFilterChange("country_id", val || "")}
                  filterOption={(input, option) =>
                    (option?.children ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                >
                  {countries.map((country, idx) => (
                    <Option key={country.id || idx} value={country.id}>
                      {country.name}
                    </Option>
                  ))}
                </Select>
              </div>

              {/* Arizachi / Tashkilot */}
              <div className="filter-item">
                <label>{t("Applicant") || "Arizachi"}</label>
                <input
                  type="text"
                  className="filter-input"
                  placeholder={t("Applicant") || "Tashkilot nomi"}
                  value={filters.applicant}
                  onChange={(e) => handleFilterChange("applicant", e.target.value)}
                />
              </div>

              {/* Boshlanish sanasi */}
              <div className="filter-item">
                <label>{t("From date") || "Boshlanish sanasi"}</label>
                <input
                  type="date"
                  className="filter-input"
                  value={filters.start_date}
                  onChange={(e) => handleFilterChange("start_date", e.target.value)}
                />
              </div>

              {/* Tugash sanasi */}
              <div className="filter-item">
                <label>{t("To date") || "Tugash sanasi"}</label>
                <input
                  type="date"
                  className="filter-input"
                  value={filters.end_date}
                  onChange={(e) => handleFilterChange("end_date", e.target.value)}
                />
              </div>
            </div>

            <div className="filter-actions">
              <div className="filter-left-actions">
                <button type="submit" className="btn-filter-search">
                  <SearchOutlined />
                  <span>{t("Filter") || "Qidirish"}</span>
                </button>

                <button
                  type="button"
                  className="btn-filter-reset"
                  onClick={handleResetFilter}
                >
                  <ReloadOutlined />
                  <span>{t("Clear") || "Tozalash"}</span>
                </button>
              </div>

              {/* Export (Yuklab olish) tugmasi */}
              <button
                type="button"
                className={`btn-filter-export ${exportLoading ? "loading" : ""}`}
                onClick={handleExport}
                disabled={exportLoading}
                title={t("Download") || "Excel formatida yuklab olish"}
              >
                {exportLoading ? (
                  <LoadingOutlined spin />
                ) : (
                  <DownloadOutlined />
                )}
                <span>
                  {exportLoading
                    ? (t("Loading...") || "Yuklanmoqda...")
                    : (t("Download") || "Yuklab olish (Export)")}
                </span>
              </button>
            </div>
          </form>
        </div>

        {/* Jadval bo'limi */}
        <div className="table-card">
          <div className="table-header-info">
            <div className="results-count">
              <span>{t("Total results") || "Jami natijalar"}: </span>
              <strong>{totalCount}</strong>
            </div>
          </div>

          {loading ? (
            <div className="table-loading">
              <Spin size="large" tip={t("Loading...") || "Yuklanmoqda..."} />
            </div>
          ) : registryItems.length > 0 ? (
            <>
              <TableContainer component={Paper} className="table-container-custom">
                <Table aria-label="certificate registry table">
                  <TableHead>
                    <TableRow className="table-head-row">
                      <TableCell>{t("Registration number") || "Reestr raqami"}</TableCell>
                      <TableCell>{t("Registration date") || "Ro'yxatdan o'tgan sana"}</TableCell>
                      <TableCell>{t("ln_col_status")}</TableCell>
                      <TableCell>{t("Drug name") || "Dori vositasi nomi"}</TableCell>
                      <TableCell>{t("Country") || "Mamlakat"}</TableCell>
                      <TableCell>{t("Manufacturer") || "Ishlab chiqaruvchi"}</TableCell>
                      <TableCell>{t("Applicant") || "Arizachi"}</TableCell>
                      <TableCell align="right" className="action-cell">
                        <span className="visually-hidden">{t("Action") || "Batafsil"}</span>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {registryItems.map((row, index) => (
                      <ReestrRow
                        key={row.id || index}
                        row={row}
                        lan={lan}
                        t={t}
                      />
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>

              {totalCount > perPage && (
                <div className="table-pagination">
                  <Pagination
                    current={currentPage}
                    pageSize={perPage}
                    total={totalCount}
                    onChange={handlePageChange}
                    showSizeChanger={false}
                  />
                </div>
              )}
            </>
          ) : (
            <div className="table-empty">
              <Empty description={t("No data") || "Ma'lumot topilmadi"} />
            </div>
          )}
        </div>
      </div>

      {/* Burchakdagi eksport loader animatsiyasi */}
      {exportLoading && (
        <div className="floating-export-loader">
          <Spin
            indicator={
              <LoadingOutlined style={{ fontSize: 24, color: "#0f766e" }} spin />
            }
          />
          <div className="loader-text">
            <strong>{t("Exporting...") || "Excel fayl tayyorlanmoqda..."}</strong>
            <span>{t("Please wait...") || "Iltimos, kuting"}</span>
          </div>
        </div>
      )}
    </div>
  );
}

export default withTranslation()(ReestrNew);
